import { ActionTree, Dispatch } from 'vuex'
import { CustomerPortalState, customerPortalMutationTypes } from '@/store/modules/customerPortal/customerPortalTypes'
import { RootState, ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { CustomerPortalService } from '@/services/CustomerPortalService'
import { DialogTypes } from '../dialog/dialogTypes'
import { i18n } from '@/plugins/vue-i18n'

const dialogModule: string = ModuleNamespaces.DIALOG

export const actions: ActionTree<CustomerPortalState, RootState> = {
  async fetchCustomerPortal({ commit }, customerId) {
    try {
      const { data } = await new CustomerPortalService().customerPortal(customerId)
      commit(customerPortalMutationTypes.FETCH_CUSTOMER_PORTAL, data[0])
    } catch (error) {}
  },
  async activateCustomerPortal({ dispatch }, customerPortalData) {
    try {
      await new CustomerPortalService().activate(customerPortalData)
      dispatch(
        `${dialogModule}/showDialog`,
        {
          type: DialogTypes.SUCCESS,
          message: i18n.t('components.customer_portal.credentials_ok_message')
        },
        { root: true }
      )
    } catch (error) {
      errorHandler(dispatch, error)
    }
  },
  async unlockCustomerPortal({ dispatch }, customerId) {
    try {
      await new CustomerPortalService().unlok(customerId)
      dispatch(
        `${dialogModule}/showDialog`,
        {
          type: DialogTypes.SUCCESS,
          message: i18n.t('components.customer_portal.activated_success_message')
        },
        { root: true }
      )
    } catch (error) {
      errorHandler(dispatch, error)
    }
  },
  async lockCustomerPortal({ dispatch }, customerId) {
    try {
      await new CustomerPortalService().lock(customerId)
      dispatch(
        `${dialogModule}/showDialog`,
        {
          type: DialogTypes.SUCCESS,
          message: i18n.t('components.customer_portal.block_success')
        },
        { root: true }
      )
    } catch (error) {
      errorHandler(dispatch, error)
    }
  },
  async deleteCustomerPortal({ dispatch }, customerId) {
    try {
      await new CustomerPortalService().delete(customerId)
      dispatch(
        `${dialogModule}/showDialog`,
        {
          type: DialogTypes.SUCCESS,
          message: i18n.t('components.customer_portal.removed_access_message')
        },
        { root: true }
      )
    } catch (error) {
      errorHandler(dispatch, error)
    }
  }
}

function errorHandler(dispatch: Dispatch, error: any) {
  const errorMessage = error.response.data.exceptionDesc
  dispatch(
    `${dialogModule}/showDialog`,
    {
      type: DialogTypes.ERROR,
      message: errorMessage
    },
    { root: true }
  )
}
